var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisitedIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icons__visited-icon",
    width: "100%",
    height: "100%",
    viewBox: "0 0 1000 1000",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M1000,250C1000,112.021 887.979,0 750,0L250,0C112.021,0 0,112.021 0,250L0,750C0,887.979 112.021,1000 250,1000L750,1000C887.979,1000 1000,887.979 1000,750L1000,250ZM399.036,625.195L221.138,499.84C198.563,483.933 167.32,489.346 151.413,511.921L93.768,593.728C77.861,616.303 83.274,647.546 105.849,663.453L394.607,866.925C397.361,868.865 400.244,870.489 403.21,871.801L407.015,874.482C429.59,890.39 460.833,884.977 476.741,862.401L906.232,252.888C922.139,230.313 916.726,199.07 894.151,183.162L812.344,125.518C789.769,109.61 758.526,115.023 742.619,137.599L399.036,625.195Z",
    style: {
      fill: "rgb(217,217,217)"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisitedIcon);
export default __webpack_public_path__ + "static/media/visited-icon.ff877f0d7b02e02352f60ecd2afafaa8.svg";
export { ForwardRef as ReactComponent };